import BankAccounts from './BankAccountsContainer';
export default BankAccounts;